import React from "react";
import IUser from "../types/user.type";
import AuthService from "../services/auth.service";
import { t, subscribeLanguage } from "../i18n";

type Props = {};

type State = {
    isModerator: boolean,
    isAdmin: boolean,
    currentUser: IUser,
}

export default class LeftSide extends React.Component<Props, State> {
    private unsubscribeLang?: () => void;

    constructor(props: any) {
        super(props);
        this.state = {
            isModerator: false,
            isAdmin: false,
            currentUser: {} as IUser,
        };
    }

    componentDidMount = () => {
        const user = AuthService.getCurrentUser();
        if (user) {
            this.setState({
                currentUser: user,
                isModerator: user.roles === "ROLE_MODERATOR",
                isAdmin: user.roles === "ROLE_ADMIN",
            });
        }
        this.unsubscribeLang = subscribeLanguage(() => this.forceUpdate());
    }

    componentWillUnmount() {
        this.unsubscribeLang?.();
    }

    render() {
        const {isAdmin} = this.state;
        return (
            <aside className="left-sidebar">
                <div className="scroll-sidebar">
                    <nav className="sidebar-nav">
                        <ul id="sidebarnav">
                            <li className="nav-devider"></li>
                            <li><a className="waves-effect waves-dark" href="/" aria-expanded="false"><i
                                className="mdi mdi-gauge"></i>{t('nav.overview')}</a></li>
                            <li><a className="waves-effect waves-dark" href="payslip" aria-expanded="false"><i
                                className="mdi mdi-cash-multiple"></i>{t('nav.payslip')}</a></li>
                            <li><a className="waves-effect waves-dark" href="calendar" aria-expanded="false"><i
                                className="mdi mdi-calendar"></i>{t('nav.calendar')}</a></li>
                            <li><a className="waves-effect waves-dark" href="contact" aria-expanded="false"><i
                                className="mdi mdi-contacts"></i>{t('nav.contact')}</a></li>
                            <li><a className="waves-effect waves-dark" href="profile" aria-expanded="false"><i
                                className="mdi mdi-account-circle"></i>{t('nav.profile')}</a></li>
                            <li><a className="waves-effect waves-dark" href="amercement" aria-expanded="false"><i
                                className="mdi mdi-clock-alert"></i>{t('nav.amercement')}</a></li>
                            <li><a className="waves-effect waves-dark" href="rules" aria-expanded="false"><i
                                className="mdi mdi-clipboard-outline"></i>{t('nav.rules')}</a></li>
                            {isAdmin ?
                                <li><a className="has-arrow waves-effect waves-dark" href="#" aria-expanded="false"><i
                                    className="mdi mdi-settings"></i><span className="hide-menu">{t('nav.admin')}</span></a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="admin.attendance">{t('nav.attendance')}</a></li>
                                        <li><a href="admin.leave">{t('nav.leave')}</a></li>
                                        <li><a href="admin.overtime">{t('nav.overtime')}</a></li>
                                        <li><a href="admin.payroll">{t('nav.payroll')}</a></li>
                                        <li><a href="admin.payslip">{t('nav.payslip')}</a></li>
                                        <li><a href="admin.setting">{t('nav.setting')}</a></li>
                                        <li><a href="admin.ruleeditor">{t('nav.rulesEditor')}</a></li>
                                    </ul>
                                </li> : <></>}
                        </ul>
                    </nav>
                </div>
            </aside>
        )
    }
}